var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagnifier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#magnifier_svg__clip0_960_249)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.68,
    cy: 15.626,
    r: 4.41,
    transform: "rotate(75 16.68 15.626)",
    stroke: "#25241D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25241D",
    d: "M10.66 22.488l-1.447-1.61 3.852-3.462 1.447 1.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 20v2H3.993A1 1 0 013 21.008V2.992C3 2.444 3.447 2 3.999 2H16l5 5v6c-1 0-1-2-2-2V8h-4V4H5v16h2z",
    fill: "#25241D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "magnifier_svg__clip0_960_249"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzk2MF8yNDkpIj4KPGNpcmNsZSBjeD0iMTYuNjgwMiIgY3k9IjE1LjYyNjMiIHI9IjQuNDEwMzIiIHRyYW5zZm9ybT0icm90YXRlKDc1IDE2LjY4MDIgMTUuNjI2MykiIHN0cm9rZT0iIzI1MjQxRCIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxyZWN0IHg9IjEwLjY1OTciIHk9IjIyLjQ4NzkiIHdpZHRoPSIyLjE2NDEzIiBoZWlnaHQ9IjUuMTc5MzUiIHRyYW5zZm9ybT0icm90YXRlKC0xMzEuOTQ2IDEwLjY1OTcgMjIuNDg3OSkiIGZpbGw9IiMyNTI0MUQiLz4KPHBhdGggZD0iTTcgMjBDNyAyMSA3IDIxLjUgNyAyMkgzLjk5M0MzLjczMDM4IDIxLjk5ODIgMy40NzkwMiAyMS44OTMxIDMuMjkzMjIgMjEuNzA3NUMzLjEwNzQyIDIxLjUyMTkgMy4wMDIwOSAyMS4yNzA2IDMgMjEuMDA4VjIuOTkyQzMgMi40NDQgMy40NDcgMiAzLjk5OSAySDE2TDIxIDdWMTNDMjAgMTMgMjAgMTEgMTkgMTFWOEgxNVY0SDVWMjBIN1oiIGZpbGw9IiMyNTI0MUQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF85NjBfMjQ5Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgMagnifier as ReactComponent };